import "./InterviewInstructionPopup.css";

export default function InterviewInstructionPopup({ visible, onClose, onStart }) {
    if (!visible) return null;

    return (
        <div className="start-interview-popup-overlay" onClick={onClose}>
            <div className="start-interview-popup" onClick={(e) => e.stopPropagation()}>
                <h2>Before You Start</h2>
                <ul className="instruction-list">
                    <li>💬 All questions are taken from <strong>real interviews</strong>.</li>
                    <li>🧠 You can <strong>attempt only once</strong>.</li>
                    <li>🚫 You <strong>cannot go back</strong> to previous questions.</li>
                    <li>🎥 Appear as a <strong>real interviewee</strong> — answer confidently.</li>
                    <li>⏱ No time limit, but try to finish within <strong>45–60 minutes</strong>.</li>
                    <li>📱 Make sure your device is charged and internet is stable.</li>
                </ul>

                <div className="start-interview-popup-buttons">
                    <button className="start-interview-popup-cancel" onClick={onClose}>Cancel</button>
                    <button className="start-interview-popup-start" onClick={onStart}>Start Interview</button>
                </div>
            </div>
        </div>

    );
}
